<template>
  <v-navigation-drawer ref="drawer" v-model="drawer" app clipped bottom hide-overlay class="navdrawer no-overflow" :height="navDrawerHeight" 
  width="300" >
      <v-row  justify="center" align="center" class="pa-0 ma-0">
        <v-col cols="11" class="pa-0 pt-2" >
          <search-field :loading="resourcesLoading" ref="searchfieldref" />
        </v-col>
      </v-row>
    <v-divider class="pa-0 ma-0" />
    <v-container :style="'height:'+(navDrawerHeight-180)+'px !important; overflow-y:auto'" max>
      <cameras-list :navDrawerHeight="navDrawerHeight" />
    </v-container>
    <v-divider />
    <v-card style="height:100px !important">
      <v-card-subtitle class="pa-0 ma-0 text-center"> <v-icon>mdi-view-grid-plus-outline</v-icon> Grid</v-card-subtitle>
      <v-row align="start" justify="start" class="pb-0 mb-0 mr-2">
        <v-col v-for="(qt,index) in cameras" v-bind:key="'camQt'+index" :cols="12/cameras.length"  class="mx-0 p-x0">
          <v-btn @click.stop="camerasInDisplay = qt"  class="mx-0 p-x0" :disabled="qt===camerasInDisplay"> {{qt}}</v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-navigation-drawer>

</template>

<script>
export default {
  data(){
    return {
      navigation: {
        width: 300,
        borderSize: 4
      },
      cameras: [1,4,9,16]
    }
  },
  components: {
    SearchField: ()=> import('@/components/basics/SearchField'),
    CamerasList: ()=> import('@/components/basics/CamerasList')
  }, 
  computed: {
    drawer:{
      get(){
        return this.$store.getters.getDrawer
      },
      set(value){
        this.$store.commit('setDrawer', value)
      }
    },
    windowSize:function(){
      return this.$store.getters.getWindowSize
    },
    navDrawerHeight: function(){
      return this.$store.getters.getNavDrawerHeight
    },
    resourcesLoading: {
      get(){
        return this.$store.getters.getResourcesLoading
      },
      set(value){
        this.$store.commit('setResourcesLoading', value)
      }
    },
    camerasInDisplay:{
      get(){
        return this.$store.getters.getCamerasInDisplay
      },
      set(value){
        this.$store.commit('setCamerasInDisplay', value)
      }
    }
  },
  methods: {
    setBorderWidth() {
      let i = this.$refs.drawer.$el.querySelector(
        ".v-navigation-drawer__border"
      );
      i.style.width = this.navigation.borderSize + "px";
      i.style.cursor = "ew-resize";
    },
    setEvents() {
      const minSize = this.navigation.borderSize;
      const el = this.$refs.drawer.$el;
      const drawerBorder = el.querySelector(".v-navigation-drawer__border");
      
      

      drawerBorder.addEventListener(
        "mousedown",
        (e) => {
          if (e.offsetX < minSize) {
            el.style.transition = "initial";
            document.addEventListener("mousemove", this.resize, true);
          }
        },
        false
      );

      document.addEventListener(
        "mouseup",
        () => {
          el.style.transition = "";
          this.$refs.drawer.width = el.style.width;
          document.body.style.cursor = "";
          document.removeEventListener("mousemove", this.resize, true);
        },
        false
      );
    },
    resize(e) {
      document.body.style.cursor = "ew-resize";
      const el = this.$refs.drawer.$el;
      const direction = el.classList.contains("v-navigation-drawer--right")
        ? "right"
        : "left";
      let f =
        direction === "right"
          ? document.body.scrollWidth - e.clientX
          : e.clientX;
      el.style.width = f + "px";
      this.$store.commit('setNavigationDrawerWidth',f)
    }
  },
   mounted() {
    this.setBorderWidth();
    this.setEvents();
  }
  
}
</script>
<style scoped>

</style>